import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {telegramChatAPI} from 'entities/notification';
import TelegramWithButton from 'shared/ui/icons/TelegramWithButton';
import {runtimeEnv} from 'shared/lib/runtimeEnv';

import {ICreateGatedModalProps} from 'entities/user';

import BotChatModal from '../NotifyChannel/BotChat/BotChatModal';

const TelegramChatModal: React.FC<ICreateGatedModalProps> = ({open, handleClose}) => (
    <BotChatModal
        open={open}
        handleClose={handleClose}
        header={t`Добавить чат`}
        botUrl={AppUrls.TELEGRAM_BOT}
        buttonIcon={<TelegramWithButton/>}
        useAddMutation={telegramChatAPI.useAddMutation}
        intro={
            <>
                {t`Нажмите`} <b>«{t`Получить токен`}»</b> {t`и выберите «Запустить» или отправьте команду `}
                <b>/start</b> — {t`бот пришлёт токен, который нужно ввести в форму ниже`}.
                {t`Для подключения группы добавьте бота`}&nbsp;
                <a
                    href={AppUrls.TELEGRAM_BOT}
                    target="_blank"
                    rel="noreferrer"
                >
                    @{runtimeEnv('REACT_APP_TELEGRAM_BOT_NAME')}
                </a>
                &nbsp;{t`в чат и также отправьте`}
                <b>/start</b> — {t`токен придёт в ответ`}.
            </>
        }
    />
);

export default TelegramChatModal;
